export default [
  {
    path: "/Report/FreightCostReport",
    name: "FreightCostReport",
    component: () => import("@/components/Report/FreightCostReport.vue"),
    meta: {
      title:'FreightCostReport',
      menuTitle: "Freight Cost Report",
      name: "FreightCostReport",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path:"/Report/OrderReport",
    name:"OrderReport",
    component:()=>import("@/components/Report/OrderReport.vue"),
    meta:{
      menuTitle: "Order Report",
      name:"OrderReport",
      requiresAuth:true
    },
    props:true
  },
  {
    path:"/Report/RelationOrderReport",
    name:"RelationOrderReport",
    component:()=>import("@/components/Report/RelationOrderReport.vue"),
    meta:{
      name:"RelationOrderReport",
      menuTitle: "Relation Order Report",
      requiresAuth:true
    },
    props:true
  },
  {
    path:"/Report/ShipmentReport",
    name:"ShipmentReport",
    component:()=>import("@/components/Report/ShipmentReport.vue"),
    meta:{
      name:"ShipmentReport",
      menuTitle: "Shipment Report",
      requiresAuth:true
    },
    props:true
  },
  {
    path:"/Report/ServiceLevelReport",
    name:"ServiceLevelReport",
    component:()=>import("@/components/Report/ServiceLevelReport.vue"),
    meta:{
      name:"ServiceLevelReport",
      menuTitle: "Service Level Report",
      requiresAuth:true
    },
    props:true
  },
  {
    path:"/Report/SummaryServiceLevelReport",
    name:"SummaryServiceLevelReport",
    component:()=>import("@/components/Report/SummaryServiceLevelReport.vue"),
    meta:{
      name:"SummaryServiceLevelReport",
      menuTitle: "Summary Service Level Report",
      requiresAuth:true
    },
    props:true
  },
  {
    path:"/Report/TransporterUtilizationReport",
    name:"TransporterUtilizationReport",
    component:()=>import("@/components/Report/TransporterUtilizationReport.vue"),
    meta:{
      name:"TransporterUtilizationReport",
      menuTitle: "Transporter Utilization Report",
      requiresAuth:true
    },
    props:true
  },
  {
    path:"/Report/DOVSDeliveryToCustomerReport",
    name:"DOVSDeliveryToCustomerReport",
    component:()=>import("@/components/Report/DOVSDeliveryToCustomerReport.vue"),
    meta:{
      name:"DOVSDeliveryToCustomerReport",
      menuTitle: "DO VS Delivery to Customer Report",
      requiresAuth:true
    },
    props:true
  },
  {
    path: "/Report/AppointmentPerformanceReport",
    name: "AppointmentPerformanceReport",
    component: () => import("../components/Report/AppointmentPerformanceReport.vue"),
    meta: {
      name: "AppointmentPerformanceReport",
      menuTitle: "Appointment Performance Report",
      requiresAuth: false,
    },
    // props(route) {
    //   console.log(route);
    //   console.log("route");
    //   return { model: { p: "p", q: "q" } };
    // },
    props:true
  },
  {
    path: "/Report/UserReport",
    name: "UserReport",
    component: () => import("../components/Report/UserReport.vue"),
    meta: {
      name: "UserReport",
      menuTitle: "User Report",
      requiresAuth: false,
    },
    // props(route) {
    //   console.log(route);
    //   console.log("route");
    //   return { model: { p: "p", q: "q" } };
    // },
    props:true
  },
  {
    path: "/Report/ShowReport",
    name: "ShowReport",
    component: () => import("../components/Report/ShowReport.vue"),
    meta: {
      name: "ShowReport",
      menuTitle: "Show Report",
      requiresAuth: false,
    },
    // props(route) {
    //   console.log(route);
    //   console.log("route");
    //   return { model: { p: "p", q: "q" } };
    // },
    props:true
  },
  {
    path:"/Report/SummarySpecialReleaseReport",
    name:"SummarySpecialReleaseReport",
    component:()=>import("@/components/Report/SummarySpecialReleaseReport.vue"),
    meta:{
      name:"SummarySpecialReleaseReport",
      menuTitle: "Summary Special Release Report",
      requiresAuth:true
    },
    props:true
  },
  {
    path: "/Report/STOReport",
    name: "STOReport",
    component: () => import("../components/Report/STOReport.vue"),
    meta: {
      name: "STOReport",
      menuTitle: "STO Report",
      requiresAuth: false,
    },
    props:true
  },
  {
    path: "/Report/SPOReport",
    name: "SPOReport",
    component: () => import("../components/Report/SPOReport.vue"),
    meta: {
      name: "SPOReport",
      menuTitle: "SPO Report",
      requiresAuth: false,
    },
    props:true
  },
  
];
